/** @jsx jsx */
/** @jsxFrag null */
import {Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import css from './index.inline.styl';

export class EmptyData extends Component<EmptyObj> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template: () => {
        return (
          <div sel='.empty-data' attrs={{elref: `emptyData`}}>
            <div sel='.empty-data-image-wrapper' />
            <div sel='.empty-data-text'>No data for this report</div>
          </div>
        );
      },
    };
  }
}

export const EmptyDataEl = defineAndMakeJsxFactory(`mp-empty-chart-data`, EmptyData);
export const EmptyDataReact = panel2react(`mp-empty-chart-data`, EmptyData);
